module.exports = __webpack_public_path__ + "static/media/close.725b288f.svg";